import React from 'react';
import { formatCurrency } from '../../../lib/helpers/formatters';
import { ADMIN_TYPES, INVOICES_ALLOWED_TYPES } from '../../../App';
import { useAuth } from '../../../commons/Auth';

const TotalTr = ({ totals = {}, profileType = '' }) => {
  const {
    netTotals = 0,
    grossTotals = 0,
    paymentsTotals = 0,
    extraGrossTotals = 0,
    adminShareTotals = 0,
    extraShareTotals = 0,
  } = totals;

  return (
    <tr className="summary-tr">
      {['SUPPLIER'].includes(profileType) && <td>-</td>}
      <td>-</td>
      <td>-</td>
      <td>-</td>
      {['SUPPLIER'].includes(profileType) && <td>-</td>}
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td className="txt-table-right">{formatCurrency(netTotals)}</td>
      <td className="txt-table-right">{formatCurrency(grossTotals)}</td>
      <td className="txt-table-right">{formatCurrency(extraShareTotals)}</td>
      {profileType !== 'UTILIZER' && (
        <td className="txt-table-right">{formatCurrency(adminShareTotals)}</td>
      )}
      <td className="txt-table-right">{formatCurrency(paymentsTotals)}</td>
      {[...ADMIN_TYPES, 'UTILIZER'].includes(profileType) && <td>-</td>}
      {[...ADMIN_TYPES, 'UTILIZER'].includes(profileType) && <td>-</td>}
      {[...ADMIN_TYPES, 'UTILIZER'].includes(profileType) && <td>-</td>}
      <td>-</td>
      <td>-</td>
      <td>-</td>
      <td>-</td>
      {['SUPPLIER'].includes(profileType) && <td>-</td>}
    </tr>
  );
};

export default TotalTr;
